import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

export const usePlanHasCustomizeCommunity = () => {
  const { currentCommunity } = usePunditUserContext();
  return Boolean(currentCommunity?.customize_community_feature_flag_enabled);
};
